// extracted by mini-css-extract-plugin
module.exports = {"back":"AdminAuto_back__M4m9e","organizar":"AdminAuto_organizar__3BWVd","caja":"AdminAuto_caja__3jc5I"};